const H = {
  mounted(o, t) {
    if (!(t.value?.isEnable || !1))
      return;
    m(o, t);
    const e = () => m(o, t);
    window.addEventListener("scroll", e, !0), window.addEventListener("resize", e), o._repositionDropdown = e;
  },
  updated(o, t) {
    const s = t.value?.isEnable || !1, e = t.value?.currentVisibleState || !1;
    if (!s)
      return;
    const f = t.value?.listEl, p = _(f);
    p || m(o, t);
    const i = x(o), c = (r, d = !1) => {
      r && (d ? (r.style.pointerEvents = "auto", r.classList.remove("scroll-disabled")) : (r.style.pointerEvents = "none", r.classList.add("scroll-disabled")));
    };
    let n;
    const a = () => {
      i && !p && (clearTimeout(n), n = setTimeout(() => {
        m(o, t);
      }, 300));
    }, l = (r) => {
      i && r.offsetX >= i?.clientWidth - i.offsetWidth && c(i, !0);
    };
    i && e ? (c(i, !1), i.addEventListener("mousedown", l)) : i && !e && (c(i, !0), i.addEventListener("mousedown", l), i.addEventListener("scroll", a));
    const y = () => {
      i && !p && (i.removeEventListener("mousedown", l), i.removeEventListener("scroll", a), c(i, !0));
    };
    o._cleanup = y || (() => {
    });
  },
  beforeUnmount(o) {
    o._repositionDropdown && (window.removeEventListener("scroll", o._repositionDropdown, !0), window.removeEventListener("resize", o._repositionDropdown)), o._cleanup && typeof o._cleanup == "function" && o._cleanup();
  }
};
function x(o) {
  let t = o.parentElement;
  for (; t; ) {
    const s = window.getComputedStyle(t).overflowY;
    if ((s === "auto" || s === "scroll") && t.scrollHeight > t.clientHeight)
      return t;
    t = t.parentElement;
  }
  return null;
}
function F() {
  const o = document.body, t = window.getComputedStyle(o);
  return {
    top: parseFloat(t.getPropertyValue("padding-top")),
    right: parseFloat(t.getPropertyValue("padding-right")),
    bottom: parseFloat(t.getPropertyValue("padding-bottom")),
    left: parseFloat(t.getPropertyValue("padding-left"))
  };
}
function R(o) {
  const t = o.parentElement;
  if (!t) return { top: 0, right: 0, bottom: 0, left: 0 };
  const s = window.getComputedStyle(t);
  return {
    top: parseFloat(s.getPropertyValue("padding-top")),
    right: parseFloat(s.getPropertyValue("padding-right")),
    bottom: parseFloat(s.getPropertyValue("padding-bottom")),
    left: parseFloat(s.getPropertyValue("padding-left"))
  };
}
function _(o) {
  if (!o) return !1;
  const t = window.getComputedStyle(o), s = t.visibility, e = t.display, f = parseFloat(t.opacity), p = o.offsetWidth > 0 && o.offsetHeight > 0;
  return e !== "none" && s !== "hidden" && s !== "collapse" && f > 0 && p;
}
function m(o, t) {
  const s = o.getBoundingClientRect(), e = t.value?.listEl, f = getComputedStyle(o).getPropertyValue("--dropdown--width").trim() || "0", p = t.value?.extraEl, i = t.value?.isUseAbsolute || !1, c = t.value?.isTopCenter || !1, n = t.value?.marginNumber || {
    top: 6,
    left: 0,
    right: 0,
    bottom: 10
  };
  if (!e) return;
  const a = F(), l = i ? {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  } : R(e);
  e.style.visibility = "hidden", e.style.position = "absolute", setTimeout(() => {
    const y = e.getBoundingClientRect(), r = p ? p.getBoundingClientRect() : null;
    let d = y.height;
    const h = y.width;
    r && (d += r.height);
    const P = s.top - l.top - a.top, w = window.innerHeight - s.bottom - l.bottom - a.bottom, b = s.left - l.left - a.left, u = window.innerWidth - s.right - l.right - a.right, V = P >= d, C = b + s.width / 2 >= h / 2 && u + s.width / 2 >= h / 2, v = i ? 0 : l.left + a.left, E = s.left;
    if (c && V && C)
      e.style.top = `${s.top - d - n.top}px`, e.style.left = `${E - h / 2 + s.width / 2 + n.left - v}px`, e.style.bottom = "unset", e.style.transformOrigin = "bottom center";
    else if (w > 50 && (w >= d || w > P)) {
      const g = i ? s.bottom : s.height;
      e.style.top = `${g + n.top}px`, e.style.bottom = "unset", e.style.transformOrigin = "top";
    } else
      e.style.top = "unset", e.style.bottom = `${window.innerHeight - s.top + n.bottom}px`, e.style.transformOrigin = "bottom";
    if (!c || !C)
      if (u < 50 && u < b)
        e.style.left = `${E + n.left - v - (parseFloat(f) - s.width)}px`, e.style.right = "unset", e.style.transformOrigin += "left";
      else if (u >= h || u > b)
        e.style.left = `${E + n.left - v}px`, e.style.right = "unset", e.style.transformOrigin += "left";
      else {
        const g = i ? 0 : l.right + a.right;
        e.style.left = "unset";
        const S = u;
        e.style.right = `${S + n.right - g}px`, e.style.transformOrigin += " right";
      }
    const L = t.value?.sharedStyles;
    if (L)
      for (const [g, S] of Object.entries(L))
        e.style.setProperty(g, S);
    e.style.visibility = "visible";
  }, 0);
}
export {
  H as a
};
